import { useTranslation } from 'react-i18next'

export function HowToSection() {
  const { t } = useTranslation('proposal', { keyPrefix: 'Proposal.HowToSection' })
  return (
    <div className='grid'>
      <div className='grid pl-6 lg:grid-cols-12'>
        <div dangerouslySetInnerHTML={{ __html: t('Text') }} className='lg:col-span-9'></div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: t('HealthText') }}></div>
    </div>
  )
}
